import React from "react";

/** Shared back control for module page headers. */
const ModuleHeaderBack = ({
  children,
  className = "",
  type = "button",
  as: Tag = "button",
  ...props
}) => {
  const classes = ["module-header-back", className].filter(Boolean).join(" ");

  return (
    <Tag type={Tag === "button" ? type : undefined} className={classes} {...props}>
      {children}
    </Tag>
  );
};

export default ModuleHeaderBack;
